module.exports = __webpack_public_path__ + "img/finney.10a4aa81.jpg";